import { fetchCurrentConversationMessages } from './fetchCurrentConversationMessages';

export const SET_CURRENT_CONVERSATION = 'SET_CURRENT_CONVERSATION'

const setCurrentConversationAction = (payload) => ({ type: SET_CURRENT_CONVERSATION, payload })

export const setCurrentConversation = (conversation) => {
  return (dispatch) => {
    dispatch(setCurrentConversationAction(conversation))
    dispatch(fetchCurrentConversationMessages(conversation))
  }
}
